const initialState = { fetching: false, exportData: [], autoReport: [], autoReportLog: [], processorReportData: [], settlementSummary: [] };

export const EXPORTREDUCER = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_EXPORT_LOADING':
            return {
                ...state,
                fetching: action.data
            }
        case 'SET_EXPORT':
            return {
                ...state,
                exportData: action.data
            }
        case 'SET_AUTO_REPORT':
            return {
                ...state,
                autoReport: action.data
            }
        case 'SET_AUTO_REPORT_LOG':
            return {
                ...state,
                autoReportLog: action.data
            }
        case 'SET_PROCESSOR_REPORT_DATA':
            return {
                ...state,
                processorReportData: action.data
            }
        case 'SET_SETTLEMENT_SUMMARY':
            return{
                ...state,
                settlementSummary: action.data
            }    
        default:
            return state;
    }
}